import { render, staticRenderFns } from "./Changes.Vue?vue&type=template&id=1bf80b52"
import script from "./Changes.Vue?vue&type=script&lang=js"
export * from "./Changes.Vue?vue&type=script&lang=js"
import style0 from "./Changes.Vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Changes.Vue
// module id = 141
// module chunks = 0